import Navbar from "../../../../components/Navbar";
import "../../css/nav.css"
import Logo from "../../../../assets/icon_no-cursive.png"

const HomeHeader = () => {
    return (
        <header className="home__header">
            <Navbar/>
            <div className="home__header-content">
                <div className="home__header-img">
                    <img src={Logo} alt="logo"/>
                </div>
                <h2 className="text-cursive">Lea & Nick</h2>
                <h3>June 20, 2026 &bull; PITTSBURGH, PA</h3>
            </div>
        </header>
    );
};

export default HomeHeader;